import 'core-js/modules/es.array.from.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Text } from './text.js';

/**
 * List
 * ====
 *
 * Creates a skeleton that looks like a list
 *
 * -----------------------------------------------------------------------------
 *
 * @param lines - Amount of lines to be rendered
 * @param borders - Render borders between lines
 *
 * -----------------------------------------------------------------------------
 *
 * @example
 * ```
 *   <Skeleton.List lines={3} borders />
 * ```
 */
var List = function List(_ref) {
  var _ref$lines = _ref.lines,
    lines = _ref$lines === undefined ? 1 : _ref$lines,
    borders = _ref.borders;
  var linesArr = Array.from(Array(lines).keys());
  return jsx("div", {
    role: "table",
    className: "cogs-v10 cogs-list",
    children: linesArr.map(function (lineNum) {
      return jsx("div", {
        className: classNames('list-item', {
          'list-item-border': borders && lineNum + 1 !== lines
        }),
        children: jsx(Text, {
          currentLine: lineNum,
          isOnlyLine: true
        })
      }, "skeleton-" + lineNum);
    })
  });
};

export { List };
